import { Component, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import { getChangedLog, hasLog } from '../../utils/normalize-log';
import { CHAIRMAN_EXTENSION_KEYS_CONFIG, ChangeLogsType, ConferenceKeys, LookupKeys } from '@ag-common-lib/public-api';
import { RegistrantChairmanExtensionKeys } from '@ag-common-lib/lib/models/registration/registrant-chairman-extension';
import {
  ChangesHistoryGridService
} from 'ag-common-svc/lib/components/changes-history-grid/changes-history-grid.service';

@Component({
  selector: 'ag-shr-chairman-extension-log-details',
  templateUrl: './attendee-chairman-extension-log-details.component.html',
  styleUrls: ['./attendee-chairman-extension-log-details.component.scss'],
})
export class AttendeeChairmanExtensionLogDetailsComponent {
  @Input() changeLogs: Delta;
  @Input() attendeeName: string;

  protected readonly chairmanExtensionKeysLookup = CHAIRMAN_EXTENSION_KEYS_CONFIG;
  protected readonly hasLog = hasLog;
  protected readonly ChangeLogsType = ChangeLogsType;
  protected readonly RegistrantChairmanExtensionKeys = RegistrantChairmanExtensionKeys;
  protected readonly getChangedLog = getChangedLog;

  constructor(protected changesHistoryGridService: ChangesHistoryGridService) {
  }
}
